import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableLoader from '../../Spinner/TableLoader';
import TableNoDataMessage from '../../TableMessage/TableNoDataMessage';
import { makeStyles } from '@mui/styles';
import { useDashboardNoticeQuery } from '../api/dashboardEndPoint';
import { Link } from 'react-router-dom';
import moment from 'moment';

const useStyles = makeStyles({
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    '& td, & th': {
      padding: '10px 12px',
      fontFamily: 'Poppins, sans-serif',
      fontSize: '13px',
      borderBottom: '1px solid #E8E8E8',
    },
    '& th': {
      backgroundColor: '#F8FAFC',
      color: '#475569',
      fontWeight: '600',
      textTransform: 'uppercase',
      fontSize: '11px',
      letterSpacing: '0.05em',
    },
  },
  noticeLink: {
    textDecoration: 'none',
    color: '#1E293B',
    fontWeight: 500,
    transition: 'color 0.2s ease-in-out',
    '&:hover': {
      color: '#F36167',
    },
  },
  slCell: {
    fontWeight: 600,
    color: '#64748B',
    width: '50px',
  },
  dateCell: {
    color: '#64748B',
    fontSize: '12px',
    width: '120px',
  },
  rowHover: {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#FFF8F8',
    },
  },
});

const MemberNotice = () => {
  const { allNotice, isLoading } = useDashboardNoticeQuery();
  const classes = useStyles();

  return (
    <>
      <TableContainer
        sx={{
          height: '250px',
          boxSizing: 'border-box',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#F1F5F9',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#F36167',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#E24C52',
          },
        }}
      >
        <Table aria-label='simple table' className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.slCell}>SL</TableCell>
              <TableCell>Notice Title</TableCell>
              <TableCell className={classes.dateCell}>Published</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableLoader />
            ) : (
              <>
                {allNotice?.length ? (
                  <>
                    {allNotice.map((sNotice, index) => (
                      <TableRow key={sNotice.id} className={classes.rowHover}>
                        <TableCell className={classes.slCell}>
                          {String(index + 1).padStart(2, '0')}
                        </TableCell>
                        <TableCell>
                          <Link
                            to={`/notice/${sNotice.id}`}
                            className={classes.noticeLink}
                          >
                            {sNotice.title}
                          </Link>
                        </TableCell>
                        <TableCell className={classes.dateCell}>
                          {sNotice.published_date
                            ? moment(sNotice.published_date).format('ll')
                            : 'N/A'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                ) : (
                  <TableNoDataMessage />
                )}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default MemberNotice;
